import { useState } from 'react';
import { Lightbox } from './Lightbox.jsx';

// Task reference photos (CJ 2026-09-30): numbered, captioned thumbnails —
// the steps, or what "done" should look like. Tap for full size.
export function ReferencePhotoStrip({ photos, size = 84 }) {
  const [open, setOpen] = useState(null);
  if (!photos || photos.length === 0) return null;
  return (
    <>
      {open && <Lightbox src={open} onClose={() => setOpen(null)} />}
      <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 2 }}
           onClick={(e) => e.stopPropagation()}>
        {photos.map((p, i) => (
          <button key={p.id} onClick={() => setOpen(p.url)} title={p.caption || `Photo ${i + 1}`}
            style={{ flex: `0 0 ${size}px`, padding: 0, border: 'none', background: 'none',
                     cursor: 'zoom-in', textAlign: 'left', fontFamily: 'inherit' }}>
            <img src={p.url} alt={p.caption || `Reference photo ${i + 1}`} loading="lazy"
              style={{ width: size, height: size, objectFit: 'cover', display: 'block',
                       borderRadius: 8, border: '1px solid #e0e0e0', background: '#f4f4f3' }} />
            <div style={{ fontSize: 10.5, color: '#546e7a', marginTop: 3, lineHeight: 1.25,
                          overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
              {p.caption || `Photo ${i + 1}`}
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
